<template>
    <li class="nav-item" :class="{ 'nav-item-submenu': children.length, 'nav-item-open': children.length && open, 'nav-item-expanded': children.length && active }">
        <router-link v-if="route" :to="route" class="nav-link" :class="{ 'active': active }" @click="linkClick">
            <i v-if="icon" :class="icon"></i>
            <span>{{ title }}</span>
        </router-link>
        <a v-else :href="url" :target="target" class="nav-link" :class="{ 'active': active }" @click="linkClick">
            <i v-if="icon" :class="icon"></i>
            <span>{{ title }}</span>
        </a>
        <transition name="slide" v-if="children.length">
            <ul v-if="open" class="nav nav-group-sub d-block">
                <limitless-sidebar-nav-item
                    v-for="item in children"
                    :key="item.mvid"
                    :title="item.title"
                    :url="item.url"
                    :route="item.route"
                    :target="item.target"
                    :tag="item.active_tag"
                    :active-tag="activeTag"
                ></limitless-sidebar-nav-item>
            </ul>
        </transition>
    </li>
</template>

<script>
export default {
    name: 'LimitlessSidebarNavItem',
    props: {
        title: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        route: {
            type: [String, Object],
            default: '',
        },
        target: {
            type: String,
            default: '',
        },
        children: {
            type: Array,
            default() {
                return [];
            },
        },
        tag: {
            type: String,
            default: '',
        },
        activeTag: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        open: false,
    }),
    mounted() {
        if (this.active) {
            this.open = true;
        }
    },
    methods: {
        linkClick(e) {
            if (this.children.length > 0) {
                e.preventDefault();
            }
            this.open = !this.open;
        },
    },
    computed: {
        active() {
            if (this.activeTag) {
                if (this.activeTag === this.tag) {
                    return true;
                }
                return Object.values(this.children).some((item) => this.activeTag === item.active_tag);
            }
            return false;
        },
    },
};
</script>

<style>
.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}
.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-out;
    -webkit-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
}
.slide-enter-to, .slide-leave {
    max-height: 500px;
    overflow: hidden;
}
.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>
